import React from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { canRead, canReadAny } from '../utils/roles';
import './SectionTabs.css';

// Layout compartido de los módulos con secciones internas.
// tabs: [{ to, label }] — rutas relativas a la sección.
export default function SectionTabs({ tabs, moduleTitle, moduleSubtitle, children, actions }) {
  const { user } = useAuth();
  const isAllowed = tab => tab.anyPermission ? canReadAny(user, tab.anyPermission) : !tab.permission || canRead(user, tab.permission);
  const readableTabs = tabs.filter(tab => tab.separator || tab.showWhenDenied || isAllowed(tab));
  const visibleTabs = readableTabs.filter((tab, index) => {
    if (!tab.separator) return true;
    const hasVisibleBefore = readableTabs.slice(0, index).some(item => !item.separator);
    const hasVisibleAfter = readableTabs.slice(index + 1).some(item => !item.separator);
    return hasVisibleBefore && hasVisibleAfter;
  });

  return (
    <div className="module-sections">
      {moduleTitle && (
        <header className="module-sections-header">
          <h1 className="module-sections-title">{moduleTitle==='Personal'?<Link to="/sueldos" style={{color:'inherit',textDecoration:'none'}}>Personal</Link>:moduleTitle}</h1>
          {moduleSubtitle && <p className="module-sections-subtitle">{moduleSubtitle}</p>}
        </header>
      )}
      <nav className="section-tabs" aria-label={`Secciones de ${moduleTitle || 'módulo'}`}>
        {visibleTabs.map((t, index) => t.separator ? (
          <span key={`separator-${index}`} className="section-tab-separator" aria-hidden="true" />
        ) : !isAllowed(t) ? (
          <span key={t.to} className="section-tab" role="link" tabIndex={0} aria-disabled="true" title="Tu rol no tiene acceso a esta configuración. Requiere autorización." style={{opacity:0.65,cursor:'not-allowed'}}>{t.label} 🔒</span>
        ) : (
          <NavLink
            key={t.to}
            to={t.to}
            state={moduleTitle === 'Personal' ? { employeeSection: true } : undefined}
            className={({ isActive }) => `section-tab${isActive ? ' active' : ''}${t.standby ? ' section-tab--standby' : ''}`}
            title={t.standby ? 'Pendiente de revisión' : undefined}
          >
            {t.bold ? <strong>{t.label}</strong> : t.label}
          </NavLink>
        ))}
        {actions}
      </nav>
      <div className="module-sections-content">
        {children || <Outlet />}
      </div>
    </div>
  );
}
